import { BUTTONS_SPACING, getButtonPropertiesForFiltersBarAndMorePopover } from '../quickFiltersBar/constants/quickFilterButtonProperties';
import { List, OrderedMap } from 'immutable';
import { isOperator } from 'customer-data-filters-ui/filterQueryFormat/operator/Operator';
import { Fragment } from 'react';
import { getQuickFilterComponent } from './getQuickFilterComponent';
import AdvancedFiltersButton from '../quickFiltersBar/AdvancedFiltersButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MoreQuickFiltersButton from '../quickFiltersBar/MoreQuickFiltersButton';
import { Button } from 'foundations-components/transitional/components/Button';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FixedComponentsContainer = styled.div.withConfig({
  displayName: "getFiltersBarComponents__FixedComponentsContainer",
  componentId: "sc-1j3yrx5-0"
})(["display:flex;gap:", "px;"], BUTTONS_SPACING);
export const getFiltersBarComponents = ({
  associatedRecord,
  baseFilterFamily,
  customPropertyNames,
  defaultButtonProperties,
  enableCustomFilters,
  maxCustomQuickFilters,
  enableReordering,
  forceShowClearQuickFilters,
  isQuickFilterVisible,
  getOperatorsForType,
  onClearQuickFilters,
  onClearAll,
  onCustomPropertyNamesChange,
  onValueChange,
  propertyRecords,
  quickFiltersInternalValue,
  fieldDefinitions
}) => {
  const quickFiltersConditions = quickFiltersInternalValue ? quickFiltersInternalValue.conditions : OrderedMap();
  const quickFiltersComponentsGetters = propertyRecords.reduce((acc, propertyRecord, index) => {
    const [conditionKey, condition] = quickFiltersConditions.entrySeq().find(([__key, value]) => isOperator(value) && !!value.field && value.field.name === propertyRecord.name) || [];
    const QuickFilterComponent = getQuickFilterComponent({
      associatedRecord,
      condition,
      filterFamily: baseFilterFamily,
      getOperatorsForType,
      propertyRecord,
      fieldDefinitions
    });
    if (!QuickFilterComponent) {
      return acc;
    }
    const filterFamily = quickFiltersInternalValue ? quickFiltersInternalValue.filterFamily : baseFilterFamily;
    const keyPath = conditionKey ? List.of(conditionKey) : undefined;
    return Object.assign({}, acc, {
      [propertyRecord.name]: buttonProperties => /*#__PURE__*/_jsx(QuickFilterComponent, {
        associatedRecord: associatedRecord,
        buttonProperties: buttonProperties,
        condition: condition,
        filterFamily: filterFamily,
        isFirst: index === 0,
        property: propertyRecord,
        onValueChange: onValueChange(keyPath)
      })
    });
  }, {});
  const getQuickFilterComponents = buttonProperties => {
    return Object.keys(quickFiltersComponentsGetters).reduce((acc, propertyName) => Object.assign({}, acc, {
      [propertyName]: quickFiltersComponentsGetters[propertyName](buttonProperties)
    }), {});
  };
  const {
    filtersBarButtonProperties,
    morePopoverButtonProperties
  } = getButtonPropertiesForFiltersBarAndMorePopover(defaultButtonProperties);
  const filtersBarsQuickFiltersComponents = getQuickFilterComponents(filtersBarButtonProperties);
  const morePopoverQuickFiltersComponents = getQuickFilterComponents(morePopoverButtonProperties);
  const quickFiltersPropertyNames = Object.keys(morePopoverQuickFiltersComponents);
  const hiddenQuickFiltersPropertyNames = quickFiltersPropertyNames.filter(propertyName => !isQuickFilterVisible(propertyName));
  const hiddenQuickFiltersComponents = hiddenQuickFiltersPropertyNames.map(propertyName => /*#__PURE__*/_jsx(Fragment, {
    children: morePopoverQuickFiltersComponents[propertyName]
  }, `${propertyName}-more-popover-filter-component`));
  const isMoreButtonActive = quickFiltersConditions.some(value => isOperator(value) && !!value.field && hiddenQuickFiltersPropertyNames.includes(value.field.name));
  const isHiddenQuickFiltersVisibilityCalculated = hiddenQuickFiltersPropertyNames.every(propertyName => isQuickFilterVisible(propertyName) !== undefined);
  const fixedComponents = /*#__PURE__*/_jsxs(FixedComponentsContainer, {
    children: [/*#__PURE__*/_jsx(MoreQuickFiltersButton, {
      allPropertyNames: quickFiltersPropertyNames,
      buttonProperties: filtersBarButtonProperties,
      customPropertyNames: customPropertyNames,
      enableCustomFilters: enableCustomFilters,
      maxCustomQuickFilters: maxCustomQuickFilters,
      enableReordering: enableReordering,
      overflowingQuickFiltersComponents: hiddenQuickFiltersComponents,
      isActive: isMoreButtonActive,
      isQuickFiltersVisibilityCalculated: isHiddenQuickFiltersVisibilityCalculated,
      onCustomPropertyNamesChange: onCustomPropertyNamesChange
    }), (quickFiltersConditions.size > 0 || forceShowClearQuickFilters) && /*#__PURE__*/_jsx(Button, {
      onClick: () => {
        onClearAll === null || onClearAll === void 0 || onClearAll();
        onClearQuickFilters === null || onClearQuickFilters === void 0 || onClearQuickFilters();
      },
      size: defaultButtonProperties.BUTTON_SIZE,
      use: defaultButtonProperties.BUTTON_USE,
      "data-selenium-test": "FiltersBarUI-clearAll",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.quickFiltersBar.clearAll"
      })
    }), /*#__PURE__*/_jsx(AdvancedFiltersButton, {
      buttonProperties: filtersBarButtonProperties
    })]
  });
  return {
    fixedComponents,
    quickFiltersComponents: filtersBarsQuickFiltersComponents
  };
};